import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { RouteHelper } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth.service';
import { CoursesService } from '../../services/courses.service';
import { IEnrollQueryParams } from './enroll.viewmodel';

@Component({
  selector: 'app-enroll',
  templateUrl: './enroll.component.html',
  styleUrls: ['./enroll.component.css']
})
export class EnrollComponent implements OnInit {

  // Course info object
  courseInfo = {
    course: '',
    agency: '',
  };

  routeParams: IEnrollQueryParams = {};

  // Agencies
  agencies: any = [];

  constructor(
    private coursesService: CoursesService,
    private router: Router,
    private auth: AuthService,
    private flashMessage: FlashMessagesService,
    private route: ActivatedRoute
  ) { }

  // Load active agencies
  ngOnInit(): void {
    this.loadRouteParams();
    this.loadAgencies();
  }

  private loadRouteParams(): void {
    const queryParams = this.route.snapshot.queryParams as IEnrollQueryParams;

    this.routeParams = RouteHelper.map(queryParams, {
      course: String,
      agency: String,
    });

    this.courseInfo.course = this.routeParams.course || '';
    this.courseInfo.agency = this.routeParams.agency || '';
  }

  private async loadAgencies() {
    await this.coursesService.getActiveAgencies().toPromise().then((data: any) => {
      this.agencies = data;
    });
  }

  // Add course to the coursesService and change route back to courses
  onSubmit() {

    // Enroll a user in the course and subscribe the the response
    this.coursesService.enrollUserInCourse(this.courseInfo, this.auth.user).toPromise().then((data: any) => {

      this.coursesService.courses = [];
      this.coursesService.currentCourse = null;

      // Success
      if (data.success) {

        // Display success
        this.flashMessage.show("Successfully enrolled in course.", {
          cssClass: 'alert-success',
          timeout: 3000
        });
      }

      // Error
      else {

        // Display error
        this.flashMessage.show(data.message, {
          cssClass: 'alert-danger',
          timeout: 3000
        });
      }
      this.router.navigate(['/courses']);
    });
  }
}
